// @flow
import React from 'react'

type ValidatorErrorProps = {
  scroll: boolean
}

export default class ValidatorError extends React.Component<ValidatorErrorProps, {}> {
  state = {}

  componentDidMount() {
    if (typeof window.scrollTo === 'function' && this.props.scroll) {
      window.scrollTo(0, 0)
    }
    return null
  }

  render(): null {
    return null
  }
}
